(function () {
  'use strict';
  angular
    .module('garanteasyApp')
    .factory('PurchasedProductWarranty', PurchasedProductWarranty);

  PurchasedProductWarranty.$inject = ['$resource', 'DateUtils', 'API_URI'];

  function PurchasedProductWarranty($resource, DateUtils, API_URI) {
    var resourceUrl = API_URI + 'api/purchased-product-warranties/:id';

    return $resource(resourceUrl, {}, {
      'query': {method: 'GET', isArray: true},
      'get': {
        method: 'GET',
        transformResponse: function (data) {
          if (data) {
            data = angular.fromJson(data);
            data.expirationDate = DateUtils.convertLocalDateFromServer(data.expirationDate);
          }
          return data;
        }
      },
      'update': {
        method: 'PUT',
        transformRequest: function (data) {
          var dataToSend = angular.copy(data);
          dataToSend.expirationDate = DateUtils.convertLocalDateToServer(dataToSend.expirationDate);
          return angular.toJson(dataToSend);
        }
      },
      'save': {
        method: 'POST',
        transformRequest: function (data) {
          var dataToSend = angular.copy(data);
          dataToSend.expirationDate = DateUtils.convertLocalDateToServer(dataToSend.expirationDate);
          return angular.toJson(dataToSend);
        }
      }
    });
  }
})();
